import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import React from "react";
import { useEffect,useState } from "react";


// summary: 確認ダイアルログを表示する。
// param1 : String msg 表示文言
// param2 : noolean isOpen ダイアログ表示状態
// param3 : function doYes Yes押下時アクション
// param4 : function doNo No押下時アクション
// return : function 


function CommonDialog ({msg, isOpen, doYes, doNo}){

    const [open, setOpen] = useState(false)

    useEffect(() => {
        setOpen(isOpen)
      }, [isOpen])
    
    return (
        <div>
            <Dialog
                open={open}
                keepMounted
                onClose={()=>doNo()}
                aria-labelledby="common-dialog-title"
                aria-describedby="common-dialog-description"
                >
                <DialogContent>
                    {msg}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => doNo()} color="primary">
                    No
                    </Button>
                    <Button onClick={() => doYes()} color="primary">
                    Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}
export default CommonDialog